export default __webpack_public_path__ + "static/media/slider_5-xs@1x.afe9ca2f.webp";